import React from 'react';
import { Text, View, ScrollView, Image, Pressable, Linking, Platform } from 'react-native';
import { FontAwesome, MaterialCommunityIcons } from '@expo/vector-icons';
import { styles } from '../utils/styles';
import { colors } from '../utils/colors';
import { WebView } from 'react-native-webview';
import { LinearGradient } from 'expo-linear-gradient';

const EventScreen = ({ navigation, route }) => {
	const { customEvent } = route.params;
	console.log('From evnetsreen ', customEvent);

	return (
		<View>
			{/* <Image source={{ uri: customEvent.img_big_custom }} /> */}
			<LinearGradient colors={['#252250', '#212529']}>
				<View style={styles.eventContainer}>
					<ScrollView style={{ position: 'relative' }}>
						<Image style={styles.newImage} source={{ uri: customEvent.img_small }} resizeMode="cover" />
						{/* <ImageBackground style={[styles.imageBackground, styles.absoluteFillObject]} source={{ uri: customEvent.img__big }} resizeMode="cover">
					<Text style={styles.imageTitle}>{customEvent.artist}</Text>
					<View style={styles.overlay} />
				</ImageBackground> */}

						{/* <LinearGradient colors={[colors.greyBackground, '#000']}> */}
						{/* <Image style={styles.imageBackground} source={{ uri: customEvent.img_big_custom }} resizeMode="cover" /> */}

						{/* <Image style={styles.imageBackground} source={require(`${customEvent.img_big_custom}`)} resizeMode="cover" /> */}
						<View style={styles.viewStyle}>
							<View style={styles.info}>
								{customEvent.artist.length > 20 ? <Text style={[styles.artistName, { fontSize: 18 }]}>{customEvent.artist}</Text> : <Text style={styles.artistName}>{customEvent.artist}</Text>}

								<View style={styles.event__details}>
									<View style={styles.event__details__single}>
										<MaterialCommunityIcons name="clock-time-eight" size={25} style={styles.detail__icon} />
										<Text style={styles.event__details__single__bigText}>{customEvent.event_time}</Text>
										<Text style={styles.event__details__single__smallText}>
											{customEvent.dateWithMonth} {customEvent.fullYear}
										</Text>
									</View>
									<View style={styles.event__details__single}>
										<MaterialCommunityIcons name="map-marker" size={25} style={styles.detail__icon} />
										<Text style={styles.event__details__single__bigText}>{customEvent.venue}</Text>
										<Text style={styles.event__details__single__smallText}>{customEvent.venue_street}</Text>
										<Text style={styles.event__details__single__smallText}>{customEvent.venue_city}</Text>
									</View>
									<View style={styles.event__details__single}>
										<FontAwesome name="ticket" size={25} style={styles.detail__icon} />
										<Text style={styles.event__details__single__bigText}>
											{customEvent.price === 0 ? 'Gratis' : customEvent.price} {customEvent.price === 0 ? '' : 'DKK'}
										</Text>
										<Text style={styles.event__details__single__smallText}>{customEvent.price === 0 ? 'Begrænset\n antal' : 'Køb Billetter'}</Text>
									</View>
								</View>
								<View style={styles.event__genreContainer}>
									<Pressable style={({ pressed }) => [{ backgroundColor: pressed ? colors.yellow : 'rgba(0,0,0,0)' }, styles.event__singleGenre__container, styles.event__singleGenre__yellow]}>
										<Text style={[styles.event__singleGenre__text, styles.event__singleGenre__yellow]}>{customEvent.genres[0]}</Text>
									</Pressable>
									<Pressable style={({ pressed }) => [{ backgroundColor: pressed ? colors.green : 'rgba(0,0,0,0)' }, styles.event__singleGenre__container, styles.event__singleGenre__green]}>
										<Text style={[styles.event__singleGenre__text, styles.event__singleGenre__green]}>{customEvent.genres[1] || customEvent.genres[0]}</Text>
									</Pressable>
									<Pressable style={({ pressed }) => [{ backgroundColor: pressed ? colors.purple : 'rgba(0,0,0,0)' }, styles.event__singleGenre__container, styles.event__singleGenre__purple]}>
										<Text style={[styles.event__singleGenre__text, styles.event__singleGenre__purple]}>{customEvent.genres[2] || customEvent.genres[0]}</Text>
									</Pressable>
								</View>
								<View style={styles.event__heading__container}>
									<Text style={[styles.event__heading, styles.event__heading__top]}>Omkring koncerten</Text>
									<View style={styles.underline}></View>
								</View>
								<View style={styles.eventDescription}>
									<Text style={styles.artistDescription}>{customEvent.description.trim()}</Text>
									{/* {customEvent.support_for !== '0' ? (
										<Text style={[styles.artistDescription, { fontStyle: 'italic' }]}>
											{`\n${customEvent.artist} spiller til denne koncert support for`}
											<Text style={{ color: colors.white }}> {`${customEvent.support_for}`}</Text>
										</Text>
									) : (
										<Text></Text>
									)}
									{customEvent.supports !== '0' ? (
										<Text style={[styles.artistDescription, { fontStyle: 'italic' }]}>
											{`\n${customEvent.artist} får til denne koncert support af`}
											<Text style={{ color: colors.white }}> {`${customEvent.supports}`}</Text>
										</Text>
									) : (
										<Text></Text>
									)} */}
								</View>
								{customEvent.price !== 0 ? (
									<Pressable
										style={({ pressed }) => [{ backgroundColor: pressed ? colors.yellowDark : colors.yellow }, styles.ticketsButton]}
										onPress={() => {
											Linking.openURL(`${customEvent.ticket_link}`);
										}}
									>
										<Text style={styles.ticketsButton__text}>Køb Billetter nu</Text>
										<Text style={styles.ticketsButton__iconContainer}>
											<MaterialCommunityIcons name="arrow-right" size={16} style={styles.ticketsButton__icon} />
										</Text>
									</Pressable>
								) : (
									<Text></Text>
								)}
								<Text style={styles.event__heading}>Social Media</Text>
								<View style={styles.socialMediaContainer}>
									<View style={styles.socialMediaContent}>
										<Text style={styles.someText__title}>{customEvent.venue}</Text>
										<View style={styles.iconsContainer}>
											{customEvent.venue_facebook ? (
												<Pressable
													style={({ pressed }) => [{ backgroundColor: pressed ? colors.yellowDark : colors.yellow }, styles.someText]}
													onPress={() => {
														Linking.openURL(`${customEvent.venue_facebook}`);
													}}
												>
													<MaterialCommunityIcons name="facebook" size={20} style={styles.some__icon} />
												</Pressable>
											) : (
												<Text></Text>
											)}
											{customEvent.venue_instagram ? (
												<Pressable
													style={({ pressed }) => [{ backgroundColor: pressed ? colors.yellowDark : colors.yellow }, styles.someText]}
													onPress={() => {
														Linking.openURL(`${customEvent.venue_instagram}`);
													}}
												>
													<MaterialCommunityIcons name="instagram" size={20} style={styles.some__icon} />
												</Pressable>
											) : (
												<Text></Text>
											)}
											{customEvent.venue_youtube ? (
												<Pressable
													style={({ pressed }) => [{ backgroundColor: pressed ? colors.yellowDark : colors.yellow }, styles.someText]}
													onPress={() => {
														Linking.openURL(`${customEvent.venue_website}`);
													}}
												>
													<MaterialCommunityIcons name="web" size={20} style={styles.some__icon} />
												</Pressable>
											) : (
												<Text></Text>
											)}
										</View>
									</View>
									<View style={styles.socialMediaContent}>
										<Text style={styles.someText__title}>{customEvent.artist}</Text>
										<View style={styles.iconsContainer}>
											{customEvent.artist_facebook ? (
												<Pressable
													style={({ pressed }) => [{ backgroundColor: pressed ? colors.yellowDark : colors.yellow }, styles.someText]}
													onPress={() => {
														Linking.openURL(`${customEvent.artist_facebook}`);
													}}
												>
													<MaterialCommunityIcons name="facebook" size={20} style={styles.some__icon} />
												</Pressable>
											) : (
												<Text></Text>
											)}
											{customEvent.artist_instagram ? (
												<Pressable
													style={({ pressed }) => [{ backgroundColor: pressed ? colors.yellowDark : colors.yellow }, styles.someText]}
													onPress={() => {
														Linking.openURL(`${customEvent.artist_instagram}`);
													}}
												>
													<MaterialCommunityIcons name="instagram" size={20} style={styles.some__icon} />
												</Pressable>
											) : (
												<Text></Text>
											)}
											{customEvent.artist_youtube ? (
												<Pressable
													style={({ pressed }) => [{ backgroundColor: pressed ? colors.yellowDark : colors.yellow }, styles.someText]}
													onPress={() => {
														Linking.openURL(`${customEvent.artist_youtube}`);
													}}
												>
													<MaterialCommunityIcons name="youtube" size={20} style={styles.some__icon} />
												</Pressable>
											) : (
												<Text></Text>
											)}
											{customEvent.artist_website ? (
												<Pressable
													style={({ pressed }) => [{ backgroundColor: pressed ? colors.yellowDark : colors.yellow }, styles.someText]}
													onPress={() => {
														Linking.openURL(`${customEvent.artist_website}`);
													}}
												>
													<MaterialCommunityIcons name="web" size={20} style={styles.some__icon} />
												</Pressable>
											) : (
												<Text></Text>
											)}
										</View>
									</View>
								</View>
								<Text style={styles.event__heading}>Spotify</Text>
								{Platform.OS === 'web' ? (
									<View style={styles.spotify}>
										{/* <WebView source={{ uri: customEvent.spotify }} style={styles.spotifyEmbedded} /> */}
										<iframe src={`https://open.spotify.com/embed/artist/${customEvent.spotify}?utm_source=generator`} height={'80'} frameBorder={'0'} />
										{/* <SpotifyPlayer uri="spotify:artist:4S1ePBSe9jQKO4R1dKZdR9" size={size} view={view} theme={theme} /> */}
									</View>
								) : (
									<View style={{ display: 'flex', flexDirection: 'row' }}>
										<View style={{ height: 80, width: 5, backgroundColor: colors.yellow }}></View>
										<WebView source={{ uri: `https://open.spotify.com/embed/artist/${customEvent.spotify}?utm_source=generator` }} style={{ height: 80, borderLeftColor: colors.yellow, marginBottom: 40, borderWidth: 10, borderColor: 'white' }} />
									</View>
								)}
							</View>
						</View>
					</ScrollView>
				</View>
			</LinearGradient>
		</View>
	);
};

export default EventScreen;
